import { Appearance as RNAppearance } from 'react-native';
import produce from 'immer';
import { ReaderPreferences } from '../../models';
import { ReaderTheme, ThemeMode } from '../../enums';
export const createReaderSlice = (set, get) => ({
    _readerPreferences: new ReaderPreferences(),
    getReaderPreferences: ({ theme }) => {
        return produce(get()._readerPreferences, (readerPreferences) => {
            if (!readerPreferences.theme) {
                switch (theme) {
                    case ThemeMode.LIGHT:
                        readerPreferences.theme = ReaderTheme.LIGHT;
                        break;
                    case ThemeMode.DARK:
                        readerPreferences.theme = ReaderTheme.DARK;
                        break;
                    default:
                        if (RNAppearance.getColorScheme() === "dark") {
                            readerPreferences.theme = ReaderTheme.DARK;
                        }
                        else {
                            readerPreferences.theme = ReaderTheme.LIGHT;
                        }
                        break;
                }
            }
        });
    },
    updateReaderPreferences: (update) => set((state) => ({
        _readerPreferences: {
            ...state._readerPreferences,
            ...update,
        },
    })),
});
//# sourceMappingURL=reader.js.map